import { render } from "./masterProcessRisks.vue?vue&type=template&id=8a4b3e4e&scoped=true&ts=true"
import script from "./masterProcessRisks.vue?vue&type=script&lang=ts"
export * from "./masterProcessRisks.vue?vue&type=script&lang=ts"

import "./masterProcessRisks.vue?vue&type=style&index=0&id=8a4b3e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4b3e4e"]])

export default __exports__